/// <reference path="Main.js" />
/// <reference path="Enumeration-vsdoc.js" />
/// <reference path="Strings-vsdoc.js" />

/* global moment */

window.JJK = window.JJK || {};

$.extend($.datepicker, {
	_checkOffset: function (inst, offset) {
		return offset;
	},
});

/** @typedef {object} DateControlOptions
 * @property {string} id
 * @property {string} sprache
 * @property {(function():Date)?} getMinDate
 * @property {number[]} validDays
 * @property {JQueryUI.DatepickerOptions} additionalDatePickerSettings
 */

JJK.DateControl = class {
	/** @param {DateControlOptions} options */
	constructor(options) {
		this.id = '';
		this.sprache = 'de';
		this.getMinDate = null;
		this.validDays = [0, 1, 2, 3, 4, 5, 6];
		this.additionalDatePickerSettings = {};
		for (const key of Object.keys(options ?? {})) {
			this[key] = options[key];
		}
		this.init();
	}
	init() {
		const that = this;
		if (this.getMinDate == null) {
			this.getMinDate = this.createMinDate.bind(this);
		}
		$(`#${this.id}`).attr('autocomplete', 'off');
		if (this.useInputTypeDate()) {
			// Feld mit "nur Datum" initialisieren
			const initialerWert = moment($(`#${this.id}`).val(), 'L', this.sprache);
			if (initialerWert.isValid()) {
				$(`#${this.id}`).val(initialerWert.format('L'));
			}

			$(`#${this.id}`).on('mousedown', function () {
				$(`#${that.id}`).parent().css('position', 'relative');
				$(`#tmpdate_${that.id}`).remove();
				const oldVal = $(`#${that.id}`).val();
				let datumStr = '';
				if (oldVal) {
					datumStr = moment(oldVal, 'L', that.sprache).format('YYYY-MM-DD');
				}
				const minDateStr = that.getMinDateIsoStr();
				const tempInput = $(`<input type="date" lang="de" id="tmpdate_${that.id}" ${minDateStr ? `min="${minDateStr}"` : ''} />`)
					.css({ position: 'absolute', top: 0, left: 0, 'z-index': -10 })
					.val(datumStr)
					.on('input', function () {
						const newVal = $(this).val();
						let datumStr = '';
						if (newVal) {
							datumStr = moment(newVal).locale(that.sprache).format('L');
						}
						$(`#${that.id}`).val(datumStr).trigger('change').trigger('blur');
						if (!that.isIOS()) {
							// bei iOS darf das Temp-Feld nicht gelöscht werden, da das Event bei jedem Scrollen ausgelöst wird, da iOS kein "Übernehmen"-Button hat:
							$(this).remove();
						}
					})
					.prependTo($(`#${that.id}`).parent());
				if (that.isIOS()) {
					window.setTimeout(function () {
						$(`#${that.id}`).trigger('blur');
						tempInput.trigger('focus');
					}, 0);
				} else {
					tempInput.trigger('focus');
					tempInput.trigger('click');
					window.setTimeout(function () {
						$(`#${that.id}`).trigger('blur');
					}, 0);
				}
			});
		} else {
			$(`#${this.id}`).on('keydown', function () {
				$(`#${this.id}`).datepicker('hide');
			});
			$(`#${this.id}`).datepicker({
				...this.additionalDatePickerSettings,
				regional: this.sprache === '' ? '' : $.validator.format("'{0}'", this.sprache),

				beforeShowDay: function (date) {
					const day = date.getDay();
					return [that.validDays.includes(day)];
				},

				onSelect: function (dateText, inst) {
					$(`#${this.id}Span`).css('visibility', 'hidden');
					if ($(`#${this.id}`).valid) {
						$(`#${this.id}`).valid();
					}
					if (that.onSelect) {
						that.onSelect();
					}
					$(this).triggerHandler('change');
				},
				minDate: this.getMinDate(),
			});
		}
	}
	createMinDate() {
		return new Date();
	}
	getMinDateIsoStr() {
		return moment(this.getMinDate(), 'L', this.sprache).format('YYYY-MM-DD');
	}
	useInputTypeDate() {
		if (!/iPhone|iPad|Android/i.test(navigator.userAgent)) {
			return false;
		}
		const input = document.createElement('input');
		input.setAttribute('type', 'date');

		const notADateValue = 'not-a-date';
		input.setAttribute('value', notADateValue);
		return input.value !== notADateValue;
	}
	isAndroid() {
		return /Android/i.test(navigator.userAgent);
	}
	isIOS() {
		return /iPhone|iPad/i.test(navigator.userAgent);
	}
	destroy() {
		if (!this.useInputTypeDate()) {
			$(`#${this.id}`).datepicker('setDate', null);
			$(`#${this.id}`).datepicker('destroy');
		}
	}
};
